/* CROOKED cart drawer — plan §5 contracts, ported from the approved P2 mockup.
   State mirrors /cart.js; ONE serialized mutation queue with monotonic seq;
   optimistic add w/ symmetric rollback; pause → reconcile → rebase on failure;
   reconcile-failure = paused queue + cleared busy UI + disabled checkout + retry;
   upsell anchor/candidates/exhausted persisted per cart token, shrink-only;
   Route SKU (routeins) never surfaces. Mutations send Section Rendering params. */
(function(){
  "use strict";
  var $=function(s){return document.querySelector(s)};
  var bootEl=$("[data-crk-cart]"), pairEl=$("[data-crk-pairings]");
  if(!$("#drawer"))return;
  var THRESHOLD=(parseInt(document.body.dataset.crkFreeshipThreshold,10)||150)*100;
  var ROUTE_SKU=document.body.dataset.crkRouteProtectionHandle;
  var PAIRINGS=pairEl?JSON.parse(pairEl.textContent):{};

  function mapItems(items){
    return (items||[]).map(function(it){
      return {key:it.key,handle:it.handle,title:it.product_title||it.title,price:it.price,
              qty:it.quantity,img:it.image||"",size:it.variant_title||"",variant_id:it.variant_id,loading:false};
    });
  }
  var boot=bootEl?JSON.parse(bootEl.textContent):{token:"",items:[]};
  var cart={token:boot.token||"",lines:mapItems(boot.items)};
  var queue=[],inFlight=false,seq=0,paused=false;
  var upsell=loadUpsell();

  function loadUpsell(){try{var u=JSON.parse(sessionStorage.getItem("crk_upsell")||"null");return (u&&u.token===cart.token)?u:null}catch(e){return null}}
  function saveUpsell(){try{upsell?sessionStorage.setItem("crk_upsell",JSON.stringify(upsell)):sessionStorage.removeItem("crk_upsell")}catch(e){}}

  function money(c){var n=c/100;return "$"+(n%1?n.toFixed(2):n)}
  function esc(s){return String(s).replace(/[&<>"']/g,function(ch){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[ch]})}
  function sized(url,w){if(!url)return "";return url+(url.indexOf("?")>-1?"&":"?")+"width="+w}
  function sectionsUrl(){return window.location.pathname}

  /* ---- serialized queue ---- */
  /* Rapid +/- taps on one line coalesce into the newest op instead of queueing a
     round trip per tap — the server sees one absolute quantity, not the staircase. */
  function enqueue(op){
    if(op.coalesceKey){
      for(var i=queue.length-1;i>=0;i--){
        if(queue[i].coalesceKey===op.coalesceKey){queue.splice(i,1);break}
      }
    }
    queue.push(op);pump();
  }
  function pump(){
    if(inFlight||paused||!queue.length)return;
    var op=queue.shift();inFlight=true;var mySeq=++seq;
    op.run(function(err){
      if(mySeq!==seq){inFlight=false;return}
      inFlight=false;
      if(err){paused=true;reconcile(op)}else pump();
    });
  }
  function rebase(c){
    cart.token=c.token||cart.token;
    cart.lines=mapItems(c.items);
    /* Pending queued intent outranks a lagging server snapshot: a rebase between a
       tap and its op must not flash the shopper's quantity backward. The queued op
       still delivers the intent to the server; its response converges truth. */
    queue.forEach(function(q){
      if(!q.qtyKey)return;
      var l=cart.lines.filter(function(x){return x.key===q.qtyKey})[0];
      if(l)l.qty=q.want;
      else if(q.want===0)cart.lines=cart.lines.filter(function(x){return x.key!==q.qtyKey});
    });
    if(upsell&&upsell.token!==cart.token){upsell=null}
    ensureUpsell();
  }
  function reconcile(failedOp){
    fetch("/cart.js",{headers:{"Accept":"application/json"}})
      .then(function(r){if(!r.ok)throw new Error("reconcile "+r.status);return r.json()})
      .then(function(c){
        if(failedOp&&failedOp.rollback)failedOp.rollback();
        rebase(c);
        cart.lines.forEach(function(l){l.loading=false});
        queue=queue.filter(function(q){return !q.dependsOnOptimistic});
        paused=false;$("#drawerErr").classList.remove("on");$("#checkoutBtn").disabled=false;
        render();toast("Cart re-synced");pump();
      })
      .catch(function(){
        cart.lines.forEach(function(l){l.loading=false});
        render();
        $("#drawerErr").classList.add("on");$("#checkoutBtn").disabled=true;
      });
  }
  $("#drawerRetry").addEventListener("click",function(){paused=false;$("#drawerErr").classList.remove("on");$("#checkoutBtn").disabled=false;reconcile(null)});

  /* ---- upsell anchor contract ---- */
  function ensureUpsell(){
    if(!cart.lines.length){upsell=null;saveUpsell();return}
    if(upsell)return;
    var anchor=null;
    for(var i=cart.lines.length-1;i>=0;i--){
      if(cart.lines[i].handle!==ROUTE_SKU){anchor=cart.lines[i].handle;break}
    }
    if(!anchor)return;
    var cands=(PAIRINGS[anchor]||[]).filter(function(c){return c.handle!==ROUTE_SKU});
    upsell={token:cart.token,anchor:anchor,candidates:cands,exhausted:[]};
    saveUpsell();
  }
  function visibleUpsells(){
    if(!upsell)return[];
    var inCart={};cart.lines.forEach(function(l){inCart[l.handle]=1});
    return upsell.candidates.filter(function(c){
      return !inCart[c.handle]&&upsell.exhausted.indexOf(c.handle)<0;
    });
  }

  /* ---- mutations (real fetches at the mockup's marked PORT points) ---- */
  /* Perf contract: an add settles in ONE round trip. The optimistic line renders at
     full opacity immediately (no dim — dimming is for ops that can shrink the cart);
     /cart/add.js's response carries the real line (key, price, image), which replaces
     the optimistic one. A silent in-queue /cart.js true-up follows so totals stay
     server-authoritative without blocking the perceived settle. */
  function addLine(item,opts){
    opts=opts||{};
    enqueue({dependsOnOptimistic:false,run:function(done){
      var existing=cart.lines.filter(function(l){return l.variant_id===item.variant_id})[0];
      if(existing){existing.qty+=1}
      else cart.lines.unshift({key:"optimistic-"+item.variant_id,handle:item.handle,title:item.title,
        price:item.price,qty:1,img:item.img,size:item.size||"",variant_id:item.variant_id,loading:false});
      if(opts.fromUpsell&&upsell&&upsell.exhausted.indexOf(item.handle)<0){upsell.exhausted.push(item.handle);saveUpsell()}
      render();openDrawer();
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({items:[{id:item.variant_id,quantity:1}],sections:"crk-cart-drawer",sections_url:sectionsUrl()})})
        .then(function(r){
          if(!r.ok)return r.json().catch(function(){return{}}).then(function(b){throw new Error(b.description||("add "+r.status))});
          return r.json();
        })
        .then(function(resp){
          var added=(resp.items&&resp.items[0])||resp;
          var line=cart.lines.filter(function(l){return l.variant_id===item.variant_id})[0];
          if(line&&added&&added.key){
            line.key=added.key;line.price=added.price;line.img=added.image||line.img;
            line.title=added.product_title||line.title;line.size=added.variant_title||line.size;
          }
          ensureUpsell();render();done(null);
          scheduleTrueUp();
        })
        .catch(function(e){toast(e.message||"Couldn't add that");done(e)});
      this.rollback=function(){
        var line=cart.lines.filter(function(l){return l.variant_id===item.variant_id})[0];
        if(!line)return;
        if(existing){line.qty=Math.max(1,line.qty-1)}else{cart.lines=cart.lines.filter(function(l){return l!==line})}
      };
    }});
  }
  /* Silent server true-up: rides the same serialized queue (never races a mutation),
     coalesces so N adds cost one sync, and never blocks or dims the UI. */
  function scheduleTrueUp(){
    enqueue({dependsOnOptimistic:false,coalesceKey:"true-up",run:function(done){
      fetch("/cart.js",{headers:{"Accept":"application/json"}})
        .then(function(r){if(!r.ok)throw new Error("cart "+r.status);return r.json()})
        .then(function(c){rebase(c);render();done(null)})
        .catch(function(e){done(e)});
    }});
  }
  /* Quantity intent is captured AT TAP TIME and rides the op — a rebase landing
     between taps can never regress the shopper's target. Coalescing keeps only the
     newest intent per line while a request is in flight. */
  function changeQty(key,delta){
    var target=cart.lines.filter(function(l){return l.key===key})[0];
    if(!target)return;
    var prev=target.qty,next=Math.max(0,target.qty+delta);
    target.qty=next;
    if(next===0)cart.lines=cart.lines.filter(function(l){return l!==target});
    render();
    enqueue({dependsOnOptimistic:true,coalesceKey:"qty-"+key,want:next,qtyKey:key,run:function(done){
      var want=this.want;
      fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({id:key,quantity:want,sections:"crk-cart-drawer",sections_url:sectionsUrl()})})
        .then(function(r){if(!r.ok)throw new Error("change "+r.status);return r.json()})
        .then(function(c){rebase(c);render();done(null)})
        .catch(function(e){done(e)});
      this.rollback=function(){var l=cart.lines.filter(function(x){return x.key===key})[0];if(l)l.qty=prev};
    }});
  }

  /* ---- render (transient UI) ---- */
  function render(){
    var box=$("#lines");box.innerHTML="";
    var total=0,count=0;
    cart.lines.forEach(function(l){
      total+=l.price*l.qty;count+=l.qty;
      var el=document.createElement("div");
      el.className="crk-line"+(l.loading?" is-loading":"");
      var imgHtml=l.img?'<img class="crk-line__img" src="'+esc(sized(l.img,200))+'" alt="">':'<span class="crk-line__img"></span>';
      el.innerHTML=imgHtml+
        '<div><div class="crk-line__t">'+esc(l.title)+'</div><div class="crk-line__v">'+(l.size?"Size "+esc(l.size):"")+'</div>'+
        '<span class="crk-line__qty"><button data-d="-1" aria-label="Decrease">−</button><span>'+l.qty+'</span><button data-d="1" aria-label="Increase">+</button></span></div>'+
        '<div class="crk-line__right"><span class="crk-line__p">'+money(l.price*l.qty)+'</span><button class="crk-line__rm">Remove</button></div>';
      el.querySelectorAll(".crk-line__qty button").forEach(function(b){b.addEventListener("click",function(){changeQty(l.key,parseInt(b.dataset.d,10))})});
      el.querySelector(".crk-line__rm").addEventListener("click",function(){changeQty(l.key,-l.qty)});
      box.appendChild(el);
    });
    $("#drawer").classList.toggle("is-empty",!cart.lines.length);
    $("#subTotal").textContent=money(total);
    var cc=$("#cartCount");if(cc){cc.textContent=count;cc.classList.toggle("on",count>0)}
    var ship=$("#shipBar"),fill=$("#shipFill"),msg=$("#shipMsg");
    fill.style.width=Math.min(100,total/THRESHOLD*100)+"%";
    if(total>=THRESHOLD){ship.classList.add("done");msg.textContent="You've unlocked free shipping"}
    else{ship.classList.remove("done");msg.textContent="Add "+money(THRESHOLD-total)+" more for free shipping"}
    var ups=visibleUpsells(),zone=$("#upsellZone"),row=$("#upsellRow");
    if(ups.length&&cart.lines.length){zone.hidden=false;row.innerHTML="";
      ups.forEach(function(u){
        var d=document.createElement("div");d.className="crk-up";
        var upImg=u.img?'<img src="'+esc(sized(u.img,120))+'" alt="">':'<span></span>';
        d.innerHTML=upImg+'<div><div class="crk-up__t">'+esc(u.title)+'</div><div class="crk-up__p">'+money(u.price)+'</div></div><button class="crk-up__add">Add — '+money(u.price)+'</button>';
        d.querySelector("button").addEventListener("click",function(){openSheet(u,"ctf")});
        row.appendChild(d);
      });
    } else zone.hidden=true;
  }

  /* ---- drawer chrome ---- */
  /* SHARED SCROLL LOCK. Two overlays (cart drawer, menu) both want the page
     frozen. If each cleared document.body.style.overflow on its own close, then
     closing one while the other is open would unlock the page UNDER an open
     overlay. Recompute from whether ANY overlay is currently on, never from the
     overlay that happens to be closing. */
  function setScrollLock(){
    var any=document.querySelector(".crk-drawer.on,.crk-menu.on,.crk-sheet.on");
    document.body.style.overflow=any?"hidden":"";
  }
  var lastFocus=null;
  function openDrawer(){
    closeMenu();                                  // mutually exclusive overlays
    lastFocus=document.activeElement;
    $("#drawer").classList.add("on");$("#veil").classList.add("on");
    setScrollLock();$("#cartClose").focus();
  }
  function closeDrawer(){
    if(!$("#drawer").classList.contains("on"))return;
    $("#drawer").classList.remove("on");$("#veil").classList.remove("on");
    setScrollLock();
    if(lastFocus){lastFocus.focus();lastFocus=null}
  }
  var cartOpen=$("#cartOpen");
  if(cartOpen)cartOpen.addEventListener("click",openDrawer);
  $("#cartClose").addEventListener("click",closeDrawer);
  $("#veil").addEventListener("click",closeDrawer);
  /* TOPMOST-ONLY Escape. The old handler fired all three closers unconditionally;
     once closers restore focus, that would yank focus back from an overlay that
     was never open. Close exactly one — the one on top. */
  document.addEventListener("keydown",function(e){
    if(e.key!=="Escape")return;
    if($("#sizeSheet").classList.contains("on"))return closeSheet();
    if($("#drawer").classList.contains("on"))return closeDrawer();
    if($("#crkMenu")&&$("#crkMenu").classList.contains("on"))return closeMenu();
  });
  $("#checkoutBtn").addEventListener("click",function(){window.location.href="/checkout"});

  var toastTimer=null;
  function toast(t){var el=$("#toast");el.textContent=t;el.classList.add("on");clearTimeout(toastTimer);toastTimer=setTimeout(function(){el.classList.remove("on")},2200)}

  /* ---- size sheet — global, contexts: "primary" (PDP main) / "ctf" (any upsell) ---- */
  var sheetItem=null;
  function openSheet(item,context){
    sheetItem=item;
    $("#sheetTitle").textContent="Pick a size";
    $("#sheetSub").textContent=item.title+" — "+money(item.price);
    var grid=$("#sheetSizes");grid.innerHTML="";
    var variants=item.variants||{};
    Object.keys(variants).forEach(function(sz){
      var v=variants[sz],id="sheet-sz-"+sz;
      var span=document.createElement("span");span.className="crk-size"+(v.available?"":" oos");
      span.innerHTML='<input type="radio" name="sheet-size" id="'+esc(id)+'" value="'+esc(sz)+'"'+(v.available?"":" disabled")+'><label for="'+esc(id)+'">'+esc(sz)+'</label>';
      span.querySelector("input").addEventListener("change",function(){
        var chosen=this.value;
        closeSheet();
        addLine({variant_id:variants[chosen].id,handle:sheetItem.handle,title:sheetItem.title,
                 price:sheetItem.price,img:sheetItem.img,size:chosen},{fromUpsell:context==="ctf"});
        if(context==="primary"&&window.CRKPDP)window.CRKPDP.setSize(chosen);
      });
      grid.appendChild(span);
    });
    $("#sizeSheet").classList.add("on");$("#sheetVeil").classList.add("on");
  }
  function closeSheet(){$("#sizeSheet").classList.remove("on");$("#sheetVeil").classList.remove("on");setScrollLock()}
  $("#sheetVeil").addEventListener("click",closeSheet);

  /* ---- header menu: left off-canvas drawer ---- */
  var burger=$("[data-crk-burger]"),menu=$("#crkMenu"),menuVeil=$("#menuVeil");
  var menuFocus=null;
  function closeMenu(){
    if(!menu||!menu.classList.contains("on"))return;
    menu.classList.remove("on");
    if(menuVeil)menuVeil.classList.remove("on");
    menu.setAttribute("aria-hidden","true");
    if(burger)burger.setAttribute("aria-expanded","false");
    setScrollLock();
    if(menuFocus){menuFocus.focus();menuFocus=null}
  }
  function openMenu(){
    if(!menu)return;
    closeDrawer();                                // mutually exclusive overlays
    menuFocus=document.activeElement;
    menu.classList.add("on");
    if(menuVeil)menuVeil.classList.add("on");
    menu.setAttribute("aria-hidden","false");
    if(burger)burger.setAttribute("aria-expanded","true");
    setScrollLock();
    var close=$("#menuClose");if(close)close.focus();
  }
  if(burger&&menu){
    burger.setAttribute("aria-expanded","false");
    burger.addEventListener("click",function(){
      if(menu.classList.contains("on"))closeMenu();else openMenu();
    });
    if(menuVeil)menuVeil.addEventListener("click",closeMenu);
    var mClose=$("#menuClose");if(mClose)mClose.addEventListener("click",closeMenu);
    menu.addEventListener("click",function(e){
      if(e.target.tagName==="A")closeMenu();      // tapping a link closes behind you
    });
    /* aria-modal alone contains nothing — trap Tab inside the open panel. */
    menu.addEventListener("keydown",function(e){
      if(e.key!=="Tab")return;
      var f=menu.querySelectorAll("a[href],button:not([disabled])");
      if(!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    });
    /* Crossing to desktop hides the panel via media query but would STRAND the
       veil and the body lock — an unscrollable page with no visible cause. */
    if(window.matchMedia){
      var mq=window.matchMedia("(min-width:820px)");
      var onMQ=function(ev){if(ev.matches)closeMenu()};
      if(mq.addEventListener)mq.addEventListener("change",onMQ);
      else if(mq.addListener)mq.addListener(onMQ);
    }
  }

  render();
  window.CRKDrawer={addLine:addLine,openSheet:openSheet,openDrawer:openDrawer};
})();
